<template>
    <div class="edit-name-move">
        <template v-if="noEdit">
            <div class="edit-name-move-div" @mouseenter="editShow" @mouseleave="editShow">
                <div class="edit-name-move-div-name">{{ pagenameTmp }}</div>
                <Icon class="edit-name-move-div-edit edit-name-move-edit" type="ios-create-outline" v-show="showEdit" @click.native="startEdit" size="16"></Icon>
            </div>
        </template>
        <template v-else>
            <div class="edit-name-move-div">
                <i-input v-model="changeName" class="edit-name-move-div-input" placeholder="请输入..." size="small"></i-input>
                <i-button type="info" size="small" @click="onChangeName">{{ $t('filter.confirm') }}</i-button>
                <i-button type="text" size="small" @click="closeEdit">{{ $t('filter.cancel') }}</i-button>
            </div>
        </template>
    </div>
</template>
<script>
import bus from '../../libs/bus';
import $ from '../../libs/util';

export default {
  props: {
    page: {
      type: String,
      default: '',
    },
    pagename: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    platform: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showEdit: false,
      noEdit: true,
      changeName: '',
      pagenameTmp: this.pagename,
    };
  },
  computed: {},
  watch: {
    pagename(param) {
      this.pagenameTmp = param;
    },
  },
  mounted() {
    const self = this;
    bus.$on('on-close-edit', (id) => {
      if (id !== self.id) self.closeEdit();
    });
  },
  beforeDestroy() {
    bus.$off('on-close-edit');
  },
  methods: {
    editShow() {
      this.showEdit = !this.showEdit;
    },
    startEdit() {
      const self = this;
      self.noEdit = false;
      self.$nextTick(() => {
        this.$emit('on-change-edit', this.id);
      });
    },
    closeEdit() {
      this.noEdit = true;
      this.showEdit = false;
      this.changeName = '';
    },
    onChangeName() {
      if (bus.demoTip()) return;
      this.pagenameTmp = this.changeName;
      const param = {
        pagedisplayname: this.pagenameTmp,
        //              pageid: 'pageInfo_af3cf7d29bfc',
        pagename: this.page,
        platformid: this.platform,
        productid: bus.productInfo.productid,
      };
      $.ajax.post('app/rest/page.json/modifyDisplayName', param).then(() => {
        this.$emit('on-change-name-succ', this.id, this.changeName);
        this.closeEdit();
      });
    },
  },
};
</script>
